import { ImageDetection } from "proximiio-js-library";
import { t } from "i18next";
import { MdMyLocation } from "react-icons/md";
import { cn, getSortedPOIs } from "@/lib/utils";

import useMapStore from "@/store/mapStore";
import useFeaturesStore from "@/store/featuresStore";
import { excludedAmenities } from "@/store/data";
import { useEffect, useState } from "react";
import Feature from "proximiio-js-library/lib/models/feature";

function LocateMeButton() {
  const locateMe = useMapStore((state) => state.locateMe);
  const mobileMode = useMapStore((state) => state.mobileMode);
  const kioskMode = useMapStore((state) => state.kioskMode);
  const features = useFeaturesStore((state) => state.features);
  const currentLang = useMapStore((state) => state.currentLang);
  const floors = useMapStore((state) => state.floors);
  const map = useMapStore((state) => state.map);
  const haveCustomPosition = useMapStore((state) => state.haveCustomPosition);
  const gpsMode = useMapStore((state) => state.gpsMode);
  const setCameraRecognitionFeature = useMapStore(
    (state) => state.setCameraRecognitionFeature,
  );

  const [enableGVision, setEnableGVision] = useState(
    import.meta.env.VITE_WAYDINDING_ENABLE_GVISION === "true",
  );
  const [located, setLocated] = useState(false);

  useEffect(() => {
    if (!enableGVision) {
      return;
    }
    if (navigator.mediaDevices) {
      navigator.mediaDevices.enumerateDevices().then(function (devices) {
        const videoDevices = devices.filter(
          (device) => device.kind === "videoinput",
        );
        setEnableGVision(videoDevices.length > 0);
      });
    } else {
      setEnableGVision(false);
    }
  }, [setEnableGVision, enableGVision]);

  const recognizeLocationHandler = () => {
    ImageDetection.init(
      {
        gVisionApiKey: import.meta.env.VITE_WAYFINDING_GVISION_APIKEY,
        pois: getSortedPOIs({ features, currentLang, floors }).filter(
          (item) => {
            if (excludedAmenities.includes(item.properties.amenity))
              return false;
            return true;
          },
        ),
        cameraText: t("gvision-camera-text"),
        tryAgainButtonText: t("try-again"),
        confirmButtonText: t("confirm"),
        noResultsText: t("gvision-no-results"),
        resultsHeadingText: t("gvision-results-header"),
        returnResults: 1,
        dir: currentLang === "ar" ? "rtl" : "ltr",
      },
      (item) => {
        const feature = features.find((f) => f.id === item.id);
        if (Object.keys(map).length > 0 && feature) {
          const pathPointFeature = map.findPathPoint({
            featureId: feature.id,
            displayOnMap: true,
          });
          map.centerToFeature(pathPointFeature.id);
          setCameraRecognitionFeature(pathPointFeature);
          setLocated(true);
        }
      },
    );
  };

  const handleLocateMe = () => {
    if (enableGVision && mobileMode && !haveCustomPosition) {
      if (located) {
        map.removeStartPointOnMap();
        setCameraRecognitionFeature({} as Feature);
        setLocated(false);
        return;
      }
      recognizeLocationHandler();
      return;
    }
    locateMe();
  };

  if (!kioskMode && (!mobileMode || gpsMode) && !haveCustomPosition) {
    return null;
  }

  return (
    <div
      className={cn(
        "absolute top-[calc(100dvh-130px)] z-[6] cursor-pointer rounded-full bg-white p-3 text-lg text-primary shadow-[0px_1px_6px_3px_rgba(0,0,0,0.5)] group-data-[dir=ltr]:right-5 group-data-[dir=rtl]:left-5 lg:bottom-auto lg:top-10 lg:group-data-[dir=ltr]:right-10 lg:group-data-[dir=rtl]:left-10 kiosk:bottom-[calc(28%+110px)] kiosk:top-auto kiosk:p-5 kiosk:text-3xl kiosk:group-data-[dir=ltr]:right-40 kiosk:group-data-[dir=rtl]:left-40",
        mobileMode && !located && "text-foreground",
      )}
      onClick={handleLocateMe}
    >
      <MdMyLocation />
    </div>
  );
}

export default LocateMeButton;
